// extracted by mini-css-extract-plugin
module.exports = {"root":"📦Modal__root--3JEqL","overflowTarget":"📦Modal__overflowTarget--36xSO"};